module.exports = __webpack_public_path__ + "images/graphic-arrows@2x_8d1dc20ba0da1435c221feef5f0fe930.png";